/*
 * @Descripttion: a-报修记录表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-05
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-05 13:07:38
 */

import http from '@/utils/kq/http';

const veHqBaoxiuApi = {
  //添加接口
  add(data) {
    return http.post(http.service.hq + 'veHqBaoxiu/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.hq + 'veHqBaoxiu/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.hq + 'veHqBaoxiu/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.hq + 'veHqBaoxiu/page', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.hq + 'veHqBaoxiu/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.hq + 'veHqBaoxiu/updateStatus', data);
  },
  //更新状态
  updateBaoxiu(data) {
    return http.post(http.service.hq + 'veHqBaoxiu/updateBaoxiu', data);
  }
};
export default veHqBaoxiuApi;
